const styles = () => ({
	container: {
		display: 'block',
		margin: '32px 6.25%'
	},
	label: {
		height: '18px',
		width: '100%',

		fontSize: '12px',

		color: '#B2B2B2',
		padding: 0,
		margin: 0
	},
	select: {
		width: '100%',
		height: '30px',

		fontFamily: 'Roboto',
		lineHeight: '18px',
		fontSize: '16px',
		padding: 0,
		margin: 0,

		color: 'rgba(0, 0, 0, 0.87)'
	}
});

export default styles;



// WEBPACK FOOTER //
// ./src/client/components/main/collections/language-select/styles.js